import React, { PureComponent } from "react";
import { connect } from "react-redux";
import CheckboxFilter from "../../components/filters/CheckboxListFilter";
import { updateCollapsible } from "../../actions/componentStatus/collapsibles";
import { updateFilter } from "../../actions/filter";
import { withTranslation } from "react-i18next";
import { updateHasChangedFilter } from "../../actions/componentStatus/hasChangedFilters";

const elementId = "phoneOperatingSystemFilter";
const maxShow = 5;

class PhoneOperatingSystemFilterContainer extends PureComponent {
  render() {
    const {
      t,
      updateCollapsed,
      updateFilterWithAllValues,
      updateFilter
    } = this.props;

    try {
      const phoneOperatingSystems = this.phoneOperatingSystems();

      if (phoneOperatingSystems == null || phoneOperatingSystems.length === 1) {
        return null;
      } else {
        return (
          <CheckboxFilter
            collapsed={this.collapsed()}
            maxShow={maxShow}
            onChange={updateFilter}
            onCollapseClick={updateCollapsed}
            onSelectAllClick={updateFilterWithAllValues}
            title={t("phoneOperatingSystemTitle")}
            value={this.phoneOperatingSystemId()}
            values={phoneOperatingSystems}
          />
        );
      }
    } catch (e) {
      return null;
    }
  }

  collapsed() {
    const { collapsed } = this.props;

    if (collapsed == null) {
      return true;
    } else {
      return collapsed;
    }
  }

  phoneOperatingSystemId() {
    const {
      hasChangedFilter,
      phoneOperatingSystemId,
      phoneOperatingSystemIds
    } = this.props;

    if (!hasChangedFilter || phoneOperatingSystemId.length < 1) {
      return phoneOperatingSystemIds.map(x => x.toString());
    } else {
      return phoneOperatingSystemId.map(x => x.toString());
    }
  }

  phoneOperatingSystems() {
    const { phoneOperatingSystemIds, phoneOperatingSystems } = this.props;

    if (
      phoneOperatingSystemIds.length > 0 &&
      Object.keys(phoneOperatingSystems).length > 0
    ) {
      let values = [];

      for (const id of Object.keys(phoneOperatingSystems)) {
        if (phoneOperatingSystemIds.indexOf(parseInt(id, 10)) >= 0) {
          values.push([id, phoneOperatingSystems[id].name]);
        }
      }

      return values.sort((a, b) => a[1].localeCompare(b[1]));
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    collapsed: state.componentStatus.collapsibles[elementId],
    hasChangedFilter: state.componentStatus.hasChangedFilters[elementId],
    offerType: state.offerType,
    phoneOperatingSystemId:
      state.filter[state.offerType].phoneOperatingSystemId,
    phoneOperatingSystemIds:
      state.portalData.entities.phoneOperatingSystems[`${state.offerType}Ids`],
    phoneOperatingSystems: state.portalData.entities.phoneOperatingSystems.byId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCollapsed: collapsed => {
      dispatch(updateCollapsible(elementId, collapsed));
    },
    updateFilter: (offerType, phoneOperatingSystemId) => {
      dispatch(
        updateFilter(offerType, {
          phoneOperatingSystemId: phoneOperatingSystemId
        })
      );
    },
    updateHasChangedFilter: () => {
      dispatch(updateHasChangedFilter(elementId));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    updateCollapsed,
    updateFilter,
    updateHasChangedFilter
  } = dispatchProps;
  const {
    collapsed,
    offerType,
    phoneOperatingSystemId,
    phoneOperatingSystemIds
  } = stateProps;

  return {
    ...stateProps,
    updateCollapsed: () => {
      let newValue;
      if (collapsed == null) {
        newValue = false;
      } else {
        newValue = !collapsed;
      }
      updateCollapsed(newValue);
    },
    updateFilterWithAllValues: e => {
      updateFilter(offerType, []);
    },
    updateFilter: e => {
      let newPhoneOperatingSystemIds;

      if (phoneOperatingSystemId.length > 0) {
        newPhoneOperatingSystemIds = [...new Set(phoneOperatingSystemId)];
      } else {
        newPhoneOperatingSystemIds = [...new Set(phoneOperatingSystemIds)];
      }

      if (typeof e === "object" && e !== null) {
        if (e.target.checked) {
          newPhoneOperatingSystemIds.push(parseInt(e.target.name, 10));
        } else {
          newPhoneOperatingSystemIds = newPhoneOperatingSystemIds.filter(
            v => v !== parseInt(e.target.name, 10)
          );
        }
        updateHasChangedFilter();
      }

      updateFilter(offerType, newPhoneOperatingSystemIds);
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withTranslation(["filters"])(PhoneOperatingSystemFilterContainer));
